<div aria-live="polite" class="c--loader {{loading ? 'is-loading' : ''}}">
  <p class="is-visually-hidden">{{ 'loading.message' | translate}}</p>
</div>
